import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const SEVERITY_META = {
  success: {
    Icon: CheckCircleOutlineIcon,
    color: "success.main",
    fallbackTitle: "Success",
  },
  error: {
    Icon: ErrorOutlineIcon,
    color: "error.main",
    fallbackTitle: "Error",
  },
  warning: {
    Icon: WarningAmberIcon,
    color: "warning.main",
    fallbackTitle: "Warning",
  },
  info: {
    Icon: InfoOutlinedIcon,
    color: "info.main",
    fallbackTitle: "Information",
  },
};

export default function StatusDialog({
  open,
  severity = "info",
  title,
  description,
  onClose,
  actions = [],
  dialogProps = {},
}) {
  const meta = SEVERITY_META[severity] || SEVERITY_META.info;
  const effectiveTitle = title || meta.fallbackTitle;

  const renderDescription = () => {
    if (!description) return null;
    if (React.isValidElement(description)) return description;
    return <Typography>{description}</Typography>;
  };

  const renderActions = () => {
    if (actions.length === 0) {
      return (
        <Button onClick={onClose} autoFocus>
          Close
        </Button>
      );
    }
    return actions.map(
      ({ label, onClick, variant = "text", color = "primary", closeOnClick = true, autoFocus }, index) => (
        <Button
          key={`${label}-${index}`}
          onClick={() => {
            onClick?.();
            if (closeOnClick !== false) {
              onClose?.();
            }
          }}
          variant={variant}
          color={color}
          autoFocus={autoFocus}
        >
          {label}
        </Button>
      )
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth {...dialogProps}>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <meta.Icon sx={{ color: meta.color }} fontSize="medium" />
          <Typography component="span" variant="h6">
            {effectiveTitle}
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>{renderDescription()}</DialogContent>
      <DialogActions>{renderActions()}</DialogActions>
    </Dialog>
  );
}
